import React, { useEffect } from 'react';

const JoinPage = () => {
  const isLocalhost = window.location.hostname === 'localhost';
  const iframeSrc = isLocalhost
    ? 'http://localhost:3000/signup?embed=true&source=npc'
    : 'https://www.propsourcing.com.au/signup?embed=true&source=npc';

  useEffect(() => {
    const handleMessage = (event) => {
      // You can add origin check here for security if needed
      if (event.data?.type === 'NPC_LOGIN_SUCCESS') {
        const { user, token } = event.data;

        console.log('User logged in via iframe:', user);

        // Store token in localStorage or cookie for future API calls
        if (token) {
          localStorage.setItem('npcAuthToken', token);
        }

        // Optionally: redirect, show welcome message, or close iframe
      }
    };

    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, []);

  return (
    <div className="min-h-screen bg-white pt-8 pb-16 px-4">
      <div className="max-w-3xl mx-auto text-center mb-8">
        <h1 className="text-3xl font-bold text-[#003366]">
          Join National Property Consultants. Powered by Propsourcing
        </h1>
      </div>

      <div className="max-w-3xl mx-auto border rounded shadow overflow-hidden">
        <iframe
          src={iframeSrc}
          title="Sign Up - NPC"
          width="100%"
          height="800"
          frameBorder="0"
          allowFullScreen
        />
      </div>
    </div>
  );
};

export default JoinPage;
